import FormattedMessage from 'I18n/components/FormattedMessage';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const ErrorSectionFormatter = ({
  title
}) => {
  return /*#__PURE__*/_jsx(ErrorMessage, {
    illustration: "errors/general",
    title: title || /*#__PURE__*/_jsx(FormattedMessage, {
      message: "aiAddonCopilotPreview.components.copilotPreview.sections.errorSectionTitle"
    })
  });
};
export default ErrorSectionFormatter;